var name = "Scarlet 202_2B3Pv2";
var uuid = "5bca6704-332d-4486-ae7d-88bea69f5713";
var pos = [
	0,
	0,
	0
];
var rot = [
	0,
	0,
	0
];
var size = [
	10.475,
	3.045,
	7.775
];
var anchor = [
	0.5,
	0,
	1
];
var color = "#00a9e0";
var alpha = 1;
var rg = true;
var type = "Apartment";
var children = [
	{
		name: "balcony",
		uuid: "fcdf6e7a-f70f-4c3b-a953-cabe234de606",
		pos: [
			-4.9625,
			0.145,
			-7.775
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			6.025,
			0.16,
			1.5
		],
		anchor: [
			0,
			0,
			0
		],
		color: "#cccccc",
		alpha: 1,
		rg: true,
		type: "Balcony",
		children: [
			{
				name: "floor",
				uuid: "3b8bf82e-bcdc-4f48-98eb-8a30d0146162",
				pos: [
					3.0125,
					0.08,
					0.75
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					6.025,
					0.16,
					1.5
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "BFA|01|",
				type: "Floor"
			}
		]
	},
	{
		name: "Bedroom Double",
		uuid: "16a64dc2-79e3-4efd-9fcb-0f380540bd96",
		pos: [
			-3.3,
			0.305,
			-4.135
		],
		rot: [
			0,
			180,
			0
		],
		size: [
			3.6,
			2.4384,
			3.405
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#a7dbd8",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "BedroomDouble"
		}
	},
	{
		name: "Bedroom Single",
		uuid: "8167bd01-e648-46c0-b0c1-2885a134409f",
		pos: [
			0,
			0.305,
			-4.135
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			2.4,
			2.4384,
			3.405
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#69d2e7",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "BedroomSingle"
		}
	},
	{
		name: "M4(2) Bathroom",
		uuid: "f6637b11-7aa9-46f6-91fa-c82f9decdf51",
		pos: [
			-4.1,
			0.305,
			-1.2375
		],
		rot: [
			0,
			-90,
			0
		],
		size: [
			2.2,
			2.4384,
			2
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#fe4365",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Bathroom"
		}
	},
	{
		name: "Kitchen / Living / Dining",
		uuid: "a399089a-2e9d-4b32-ad22-a6f176b12669",
		pos: [
			3.3,
			0.305,
			-3.7375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.6,
			2.4384,
			7.2
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#00a0b0",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "KitchenLivingDining",
			polygon: [
				[
					3.195,
					0.305,
					-1.0325
				],
				[
					3.195,
					0.305,
					-0.1375
				],
				[
					5.1,
					0.305,
					-0.1375
				],
				[
					5.1,
					0.305,
					-7.3375
				],
				[
					1.5,
					0.305,
					-7.3375
				],
				[
					1.5,
					0.305,
					-5.9063
				],
				[
					1.5,
					0.305,
					-2.2375
				],
				[
					1.5,
					0.305,
					-1.2375
				],
				[
					1.5,
					0.305,
					-1.0325
				],
				[
					3.195,
					0.305,
					-1.0325
				]
			]
		}
	},
	{
		name: "Storage",
		uuid: "d951589a-7a52-4656-a8d2-52d5f03760b2",
		pos: [
			-2.2525,
			0.305,
			-0.5375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			1.505,
			2.4384,
			0.8
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#556270",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Storage"
		}
	},
	{
		name: "Utility",
		uuid: "06782dcc-642d-4a5e-bfde-9b603d5651ba",
		pos: [
			2.3,
			0.305,
			-0.5375
		],
		rot: [
			0,
			90,
			0
		],
		size: [
			0.8,
			2.4384,
			1.6
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#c44d58",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Utility"
		}
	},
	{
		name: "Hallway",
		uuid: "df5fbc7c-7d77-4933-8c17-d9e9c6d8123f",
		pos: [
			-0.8212,
			0.305,
			-1.2375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			4.3675,
			2.4384,
			2.2
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#4ecdc4",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Hallway",
			polygon: [
				[
					-1.5,
					0.305,
					-1.0325
				],
				[
					-3.005,
					0.305,
					-1.0325
				],
				[
					-3.005,
					0.305,
					-2.3375
				],
				[
					-1.5016,
					0.305,
					-2.3375
				],
				[
					-1.5,
					0.305,
					-2.3375
				],
				[
					-1.2,
					0.305,
					-2.3375
				],
				[
					-1.1984,
					0.305,
					-2.3375
				],
				[
					1.1984,
					0.305,
					-2.3375
				],
				[
					1.3625,
					0.305,
					-2.3375
				],
				[
					1.3625,
					0.305,
					-1.2375
				],
				[
					1.2,
					0.305,
					-1.2375
				],
				[
					1.2,
					0.305,
					-0.1375
				],
				[
					-0.268,
					0.305,
					-0.1375
				],
				[
					-0.268,
					0.305,
					-1.0325
				],
				[
					-1.2,
					0.305,
					-1.0325
				],
				[
					-1.2,
					0.305,
					-1.2375
				],
				[
					-1.5,
					0.305,
					-1.2375
				],
				[
					-1.5,
					0.305,
					-1.0325
				]
			]
		}
	},
	{
		name: "Storage",
		uuid: "cdac8e08-883e-4fdc-a340-4ac2ad1d146d",
		pos: [
			-0.7815,
			0.305,
			-0.5375
		],
		rot: [
			0,
			-90,
			0
		],
		size: [
			0.8,
			2.4384,
			0.837
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#556270",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Storage"
		}
	},
	{
		name: "module",
		uuid: "91a15691-1f7d-4dac-a364-645e8e66be17",
		pos: [
			0,
			1.5225,
			-2.9875
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			2.675,
			3.045,
			5.975
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#00a9e0",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "89a15008-7c73-4695-afea-5c48c1bf4cb0",
				pos: [
					0,
					0.07,
					0.6025
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.4,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "75f59bae-0d8a-4a48-bbc3-10c6416633a1",
						pos: [
							0.6,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "c3dc08d7-c6b7-4f1d-b0b3-71cb387180ba",
				pos: [
					0,
					0.0725,
					-2.9187
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.4,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "e4332bae-b35f-4cdc-9d43-6180439a35e8",
						pos: [
							0,
							-0.2525,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.15,
							2.085,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DCD|01|UK-DCD0002",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "f5d0840c-fd6d-4db5-a058-672fe22ed573",
				pos: [
					-1.2688,
					0.0725,
					-0.0688
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					5.8375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "fe92f633-2fe5-4d25-8ce2-758aba13f120",
						pos: [
							1.3188,
							-0.285,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.165,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "38fb5ded-ab5c-4bfe-bc0f-d7661ce0b52e",
				pos: [
					-0.0687,
					0.0725,
					2.9188
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					2.5375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "ccf94d88-6dba-43e5-9148-91565c9900d0",
						pos: [
							-0.5637,
							-0.2275,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.01,
							2.09,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|01|UK-DIS0001",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: true
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "288d3d45-583b-4492-920c-7e201a18f501",
				pos: [
					1.2688,
					0.0725,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.975,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "92a588f3-65ad-4442-9b61-4e06b78998ee",
						pos: [
							-1.25,
							-0.285,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.165,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "41bd82e9-0c2f-4be2-8325-1429f2bcecf8",
				pos: [
					-0.3155,
					0.07,
					2.4025
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					0.895,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "e19dc720-459a-49c1-b96e-e39b35279bbf",
						pos: [
							-0.4,
							-0.2425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							0.095,
							2.09,
							0.81
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "f47dcb8e-ab20-4287-92ca-d5d09ef42339",
				pos: [
					-0.7815,
					0.07,
					2.0025
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					0.837,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "2dc33544-43ff-41ce-92f1-3e9bc7cad34b",
						pos: [
							-0.0135,
							-0.225,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							0.81,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0003",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "54219130-6ef7-4b5b-904e-7023c768d33b",
				pos: [
					0,
					-1.26,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.065,
					2.4
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "SCR|01|",
				type: "Floor"
			},
			{
				name: "beam",
				uuid: "d9625083-bd3a-4df8-84ea-12c8fe84fe29",
				pos: [
					0,
					-1.4075,
					-2.925
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.64,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "02d90f9d-fac4-43ec-b13b-c22b3652260d",
				pos: [
					0,
					-1.4075,
					2.925
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.64,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "20fba6f8-d1a7-4206-b55b-2ad2c0e9b43e",
				pos: [
					0,
					-1.372,
					-1.3512
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.625,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "ce4293b6-d832-429f-ac6f-ac657cd701a5",
				pos: [
					0,
					-1.372,
					-1.5987
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.625,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "52eae371-f8fc-412b-9f57-6894d6f411bf",
				pos: [
					0,
					-1.372,
					2.7988
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.625,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "6fd0defc-f682-4326-8288-f7b2152c31d3",
				pos: [
					0,
					-1.372,
					2.5513
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.625,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "55940fa0-a9dd-498c-809c-c6b40ec066d8",
				pos: [
					0,
					-1.3595,
					-2.8425
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.24,
					0.1,
					0.075
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "LAU|01|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "bd7a6457-06f6-4506-bdaa-7f152247e405",
				pos: [
					0,
					-1.3595,
					0.0563
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.625,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "7ad86e97-3a2e-4912-bc83-7110b206b9d3",
				pos: [
					0,
					-1.3595,
					-0.0037
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.625,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "fa1ee552-5ec9-4b33-b379-28bf78b74c83",
				pos: [
					0,
					-1.3595,
					1.3563
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.625,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "3d68ea5f-5b9b-43c0-bca3-6b1bdca30f7d",
				pos: [
					0,
					-1.3595,
					1.2963
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.625,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "ac1c5f8f-a3eb-4ad1-851d-98c3233217cf",
				pos: [
					-1.275,
					-1.4075,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.76,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "43f231df-c5f3-4214-a56a-161fed3e2794",
				pos: [
					1.275,
					-1.4075,
					0.0007
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7613,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "720138ce-f7e0-4f7d-84fb-f608572918bf",
				pos: [
					-1.275,
					0.0812,
					2.675
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "a5c868ed-c8e2-4950-b1ac-2cf314aeb931",
				pos: [
					-1.275,
					0.0812,
					-1.475
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "3b7e4e0a-1f6f-4401-b518-e1358c5b9fbf",
				pos: [
					1.275,
					0.0812,
					2.675
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "50c899e9-bf70-402c-b711-1892c5c031b4",
				pos: [
					1.275,
					0.0812,
					-1.475
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "floor",
				uuid: "a624acec-6528-40f4-b9f2-d20d921b8632",
				pos: [
					0,
					-1.2225,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.01,
					2.4
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FFN|01|",
				type: "Floor"
			},
			{
				name: "ceiling",
				uuid: "2df4cb6d-b338-43ee-b7bc-39c3b4dd6419",
				pos: [
					0,
					1.445,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.155,
					2.4
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	},
	{
		name: "module",
		uuid: "d4268095-a1bc-4dd1-8d95-a34529961f8c",
		pos: [
			-3.3,
			1.5225,
			-2.9875
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.875,
			3.045,
			5.975
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#00a9e0",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "4c1e134f-34b6-4518-bf4d-00ea84151ad1",
				pos: [
					0,
					0.0725,
					-2.9187
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.6,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "9dfa3b15-931a-404c-8adf-64b383fbada1",
						pos: [
							0,
							-0.2525,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.75,
							2.085,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DCD|01|UK-DCD0003",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "4501a90a-47a3-49f8-95d3-201a90398ce8",
				pos: [
					-1.8687,
					0.0725,
					-0.0688
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					5.8375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "72febb97-7ef8-4c2c-8f29-0c9caf9888b7",
				pos: [
					-0.0688,
					0.0725,
					2.9188
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.7375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "2dc4b37c-2c20-43a4-8d4c-082049b7f8c6",
				pos: [
					1.8687,
					0.0725,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.975,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "fe0ec75d-cdc8-44db-a5e9-bb7e9e540936",
						pos: [
							-1.25,
							-0.285,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.165,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "397ba2eb-f094-4eff-ae77-1052bab4845b",
				pos: [
					0,
					-1.26,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.065,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "SCR|01|",
				type: "Floor"
			},
			{
				name: "wall",
				uuid: "3eceb772-2697-43d3-b76e-fd345b11261e",
				pos: [
					0,
					0.07,
					0.6025
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.6,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "e944ccee-4dcf-417e-9293-4a8e3dccdb07",
						pos: [
							1.2,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "a5c7fb8d-be63-416d-ada1-0cbbee079aa1",
				pos: [
					0.2475,
					0.07,
					1.75
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					2.2,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "a14829e0-9dbe-47e3-aa8f-7e8bcad0140d",
						pos: [
							0.5,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "2c9e99ed-b58a-4841-b45f-ec6fbeb53c10",
				pos: [
					1.0475,
					0.07,
					2.0025
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					1.505,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "69a5e4ac-ba1b-40df-9059-d4ffed43c670",
						pos: [
							0.1075,
							-0.2425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.21,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DID|02|UK-DID0001",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "beam",
				uuid: "df99c38e-66aa-4089-b417-6bb59d58cf1d",
				pos: [
					0,
					-1.4075,
					-2.925
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "232b5be3-f041-44e6-a8a5-1d925fb77600",
				pos: [
					0,
					-1.4075,
					2.925
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "9e6692a7-9990-4812-9121-3f81c5ad9d4c",
				pos: [
					0,
					-1.372,
					-1.3512
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "cc6410d6-a58e-40e0-b6a0-827197e0e280",
				pos: [
					0,
					-1.372,
					-1.5987
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "d0978c26-c2f5-4d71-861c-bc7832ae6775",
				pos: [
					0,
					-1.372,
					2.7988
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "a55c5ffe-6211-4172-a09d-ae497def5110",
				pos: [
					0,
					-1.372,
					2.5513
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "c2683e40-a25a-4eb1-96ba-113ced79330f",
				pos: [
					0,
					-1.3595,
					-2.8425
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.44,
					0.1,
					0.075
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "LAU|01|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "c07de27b-e937-4b3c-9705-df35069aa91d",
				pos: [
					0,
					-1.3595,
					0.0563
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "f22aa5ff-7f6b-4881-8ded-876df6b3abe9",
				pos: [
					0,
					-1.3595,
					-0.0037
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "56f3b09a-b46d-4350-a6e5-9df763ee7db8",
				pos: [
					0,
					-1.3595,
					1.3563
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "3470b589-aec7-41a5-af43-1ad92adff8b8",
				pos: [
					0,
					-1.3595,
					1.2963
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "9bdfd7df-8910-46d7-a72b-01cfcde077c7",
				pos: [
					-1.875,
					-1.4075,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.76,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "2d5f9006-c0e3-46b9-9997-f994b1093b33",
				pos: [
					1.875,
					-1.4075,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.76,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "7f6c4344-efb6-454f-baab-1863ba20897f",
				pos: [
					-1.875,
					0.0812,
					2.675
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "c96f3bc4-9ee6-4ef2-abf1-ec38c4c0cb90",
				pos: [
					-1.875,
					0.0812,
					-1.475
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "65858c19-6b19-4d17-98ed-8288c9e7ec2a",
				pos: [
					1.875,
					0.0812,
					2.675
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "64108ad0-4110-4601-baae-7a6e9063581f",
				pos: [
					1.875,
					0.0812,
					-1.475
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "floor",
				uuid: "85677622-d7c6-40f2-9120-5f47ad2fa3a7",
				pos: [
					0,
					-1.2225,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.01,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FFN|01|",
				type: "Floor"
			},
			{
				name: "ceiling",
				uuid: "8cd39b11-2e7c-491c-8581-68ebe5a473a3",
				pos: [
					0,
					1.445,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.155,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	},
	{
		name: "module",
		uuid: "2af1dc03-d93d-4361-9701-6ed26af28e92",
		pos: [
			3.3,
			1.5225,
			-3.7375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.875,
			3.045,
			7.475
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#00a9e0",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "15c87e86-5b3e-4bf2-8361-ea0ecb254a5e",
				pos: [
					-0.1525,
					0.07,
					3.1525
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					0.895,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "90d78b71-379b-4135-bafb-c64f5ead7feb",
				pos: [
					-1,
					0.07,
					2.7525
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					1.6,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "d275806d-d816-48bb-aaeb-34f2eab03ddb",
						pos: [
							0,
							-0.2425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.21,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DID|02|UK-DID0001",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "350e78f8-08da-4c3c-b96f-c0b4e5b552fd",
				pos: [
					0,
					0.0725,
					-3.6687
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.6,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "window",
						uuid: "462aa8b7-8745-412b-9b8d-3af46a4f02b8",
						pos: [
							0,
							0.1425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.76,
							1.305,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#4b5e82",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "WNF|12|",
						type: "Window"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "53f8bb42-9a63-4bcd-872d-4d9deed4649b",
				pos: [
					-1.8687,
					0.0725,
					-0.0688
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					7.3375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "a15111f6-2ee5-46eb-96fb-afaadfbcf450",
						pos: [
							2.0688,
							-0.227,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "85346e02-e1cb-4271-9cbd-d02f450c50ca",
				pos: [
					-0.0687,
					0.0725,
					3.6688
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.7375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "5dd6d17c-ba57-44d5-aa51-51edef5aa1e9",
				pos: [
					1.8687,
					0.0725,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.475,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "32d42c58-d6fb-4dd6-bed9-5a80f99f1141",
				pos: [
					0,
					-1.26,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.2,
					0.065,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "SCR|01|",
				type: "Floor"
			},
			{
				name: "beam",
				uuid: "4fc24883-842a-411b-93d6-0ed3ad6a1dc3",
				pos: [
					0,
					-1.4075,
					-3.675
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "1a6f54cf-c85f-4e4b-aece-84e8da26e365",
				pos: [
					0,
					-1.4075,
					3.675
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "2397643f-6349-45ad-b228-b1fd9d981941",
				pos: [
					0,
					-1.372,
					-3.3013
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "561f8dd5-7182-46e3-acac-5510bb7f4f2a",
				pos: [
					0,
					-1.372,
					-3.5488
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "98eb6a2c-05cc-4a19-aed7-e58a359fe5b8",
				pos: [
					0,
					-1.372,
					3.5488
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "1b59e868-2d61-4670-9687-7dd0fe88361e",
				pos: [
					0,
					-1.372,
					3.3013
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "d1102845-9198-4b82-8fd9-bdd64d928f03",
				pos: [
					0,
					-1.3595,
					0.805
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "29259605-4c5b-41fc-80c0-0800047c6f38",
				pos: [
					0,
					-1.3595,
					0.745
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "461db66f-3af6-485b-aa93-ccb3149d02fe",
				pos: [
					0,
					-1.3595,
					2.105
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "8f11eeec-2d8c-43a8-9633-e791c64447d4",
				pos: [
					0,
					-1.3595,
					2.045
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "42711598-7f52-4693-bbdb-e9b2dc2b6fc4",
				pos: [
					-1.875,
					-1.4075,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.26,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "040f225d-db0d-4b7c-a966-21b5177ac676",
				pos: [
					1.875,
					-1.4075,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.26,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "df917e8e-2627-4826-9c3b-ac1b42238061",
				pos: [
					-1.875,
					0.0812,
					3.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "8613ae3d-fc50-440c-ab35-9490be6876bd",
				pos: [
					-1.875,
					0.0812,
					-3.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "447b4b6e-bb40-4592-9f43-3ec0d662675e",
				pos: [
					1.875,
					0.0812,
					3.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "5d65e055-d8d2-4113-a725-48331c84120b",
				pos: [
					1.875,
					0.0812,
					-3.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "51ed9301-02b1-4c06-827b-7008100ad62d",
				pos: [
					0,
					-1.372,
					-0.6012
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "8c3db304-d803-4ed6-ba30-000e0d8b8c08",
				pos: [
					0,
					-1.372,
					-0.8487
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "4404d249-cd19-42e4-b002-4a74a5b6ee39",
				pos: [
					-1.875,
					0.0812,
					-0.725
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "09079e2d-661e-449b-889f-67cc4bad40ba",
				pos: [
					1.875,
					0.0812,
					-0.725
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "d3de89af-506d-4967-9522-22e901d5ff3c",
				pos: [
					0,
					-1.3595,
					-2.035
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "80923ef5-d3f3-46c9-9493-6d7f1b0ccaf3",
				pos: [
					0,
					-1.3595,
					-2.095
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "floor",
				uuid: "437a77fa-9b03-4ae1-9d75-d9b0811c6bc5",
				pos: [
					0,
					-1.2225,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.2,
					0.01,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FFN|01|",
				type: "Floor"
			},
			{
				name: "ceiling",
				uuid: "43d32d62-1292-4c3c-8a64-c35673cb7565",
				pos: [
					0,
					1.445,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.2,
					0.155,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	}
];
var data = {
	level: -1,
	levelId: "",
	occupants: 3,
	bedrooms: 2,
	habitableRooms: 3,
	nia: 63.54,
	muscleID: "",
	category: "2B3P"
};
var UK01_2B3P_V2 = {
	name: name,
	uuid: uuid,
	pos: pos,
	rot: rot,
	size: size,
	anchor: anchor,
	color: color,
	alpha: alpha,
	rg: rg,
	type: type,
	children: children,
	data: data
};

export { alpha, anchor, children, color, data, UK01_2B3P_V2 as default, name, pos, rg, rot, size, type, uuid };
//# sourceMappingURL=Scarlet-202-2B3Pv2.json.js.map
